const trsFormContent = (content, mode) => {
  let modeContent = {}

  switch (mode) {
    case 'TRS_CONFIRM_PROPOSAL':
      modeContent = {
        collapseBtnText: content.trs_collapse_offer_btn_text,
        paragraphs: [content.trs_collapse_offer_paragraph1],
        smallText: content.trs_collapse_offer_smalltext,
        placeholder: content.trs_collapse_offer_placeholder_input,
        ctaBtnText: content.trs_collapse_offer_cta_btn,
        formFeedback: content.trs_form_feedback_confirm,
      }
      break
    case 'TRS_EDIT_PROPOSAL':
      modeContent = {
        collapseBtnText: content.trs_collapse_edit_btn_text,
        paragraphs: [content.trs_collapse_edit_paragraph1, content.trs_collapse_edit_paragraph2],
        smallText: content.trs_collapse_edit_smalltext,
        placeholder: content.trs_collapse_edit_placeholder_input,
        ctaBtnText: content.trs_collapse_edit_cta_btn,
        formFeedback: content.trs_form_feedback_edit,
      }
      break
    default:
      break
  }

  return modeContent
}

export default trsFormContent
